// extracted by mini-css-extract-plugin
export default {"textInputContainer":"TextInput_textInputContainer__OihtN","label":"TextInput_label__77G7M","textInput":"TextInput_textInput__e0Ifg"};